import * as React from "react";
import PropTypes from "prop-types";
import Popover from "@material-ui/core/Popover";

const PopOver = ({ children, render }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      {render({ onClick: handleClick })}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        {children}
      </Popover>
    </>
  );
};

PopOver.propTypes = {
  children: PropTypes.node.isRequired,
  render: PropTypes.func.isRequired
};

export default PopOver;
